export const frames = (value, fps = 25) => value / fps
